import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { StoreModule } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { reducers } from "@core/store";
import { AppRoutingModule } from "@app/app-routing.module";
import { SharedModule } from "@core/shared/shared.module";
import { AppCoreModule } from "./core/core.module";
import { AppComponent } from "./app.component";
import {
  FooterComponent,
  MenuComponent,
  SubMenuComponent,
  WelcomeComponent,
  MenuClickDirective,
  SubMenuHoverDirective,
} from "@core/private/_layout";

import { AppExtensionModule } from "./extension/extension.module";

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    MenuComponent,
    SubMenuComponent,
    WelcomeComponent,
    MenuClickDirective,
    SubMenuHoverDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    StoreModule.forRoot(reducers),
    AppCoreModule,
    AppRoutingModule,
    SharedModule,
    AppExtensionModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent],
})
export class AppModule { }
